module.exports = __webpack_public_path__ + "img/GroupsDiagram.5803c824.svg";